import { Button, Text } from '@southfields-digital/mpxlive-components';

import { DataPreview } from '../DataPreview';

import styles from './DataConnectorPanel.module.scss';

type PreviewSectionProps = {
  graphic: Graphic;
  previewData: PropertyValue;
  onImport: () => void;
  onUpdateProperty: (propertyId: string, value: string | PropertyValue[]) => void;
};

export const PreviewSection = ({
  graphic,
  previewData,
  onImport,
  onUpdateProperty,
}: PreviewSectionProps) => {
  return (
    <div className={styles.PreviewSection}>
      <div className={styles.PreviewHeader}>
        <Text as="h3" className={styles.PreviewTitle}>
          Preview Data
        </Text>
        <div className={styles.PreviewActions}>
          <Button onClick={onImport}>Import Data</Button>
        </div>
      </div>

      <DataPreview graphic={graphic} previewData={previewData} onUpdateProperty={onUpdateProperty} />
    </div>
  );
};
